/**
 * お気に入り → App Proxy POST /apps/mypage/favorites
 */
(function () {
  'use strict';

  function cfg() {
    return window.GanymedeWishlist || {};
  }

  function resolveProxyUrl(url) {
    if (!url || typeof url !== 'string') {
      return url;
    }
    var u = url.trim();
    if (/^https?:\/\//i.test(u)) {
      return u;
    }
    var origin = window.location.origin || '';
    return origin && u.charAt(0) === '/' ? origin + u : u;
  }


  function parseResponseJson(text) {
    var t = String(text || '').replace(/^\uFEFF/, '').trim();
    if (!t) {
      return { __parseError: 'empty_body' };
    }
    try {
      return JSON.parse(t);
    } catch (e1) {
      var start = t.indexOf('{');
      var end = t.lastIndexOf('}');
      if (start !== -1 && end > start) {
        try {
          return JSON.parse(t.slice(start, end + 1));
        } catch (e2) {
          return { __parseError: 'invalid_json', __snippet: t.slice(0, 200) };
        }
      }
      return { __parseError: 'invalid_json', __snippet: t.slice(0, 200) };
    }
  }

  function detectDevice() {
    var ua = navigator.userAgent || '';
    if (/Mobile|Android|iPhone|iPod/i.test(ua)) {
      return 'mobile';
    }
    return 'desktop';
  }

  function syncVariantId(variantId) {
    if (!variantId) {
      return;
    }
    document.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var section = btn.closest('product-info, [data-section-id]');
      if (!section) {
        return;
      }
      btn.setAttribute('data-variant-id', String(variantId));
      paintButton(btn);
    });
  }

  /* ===== お気に入り済みの見た目（ハートを塗りつぶす） =====
     ⚠️ バリエーション単位で持つ。商品単位にすると、別のバリエーションを
        選んでいるのに塗られたままになる。 */
  var favorited = null;

  function favoritedSet() {
    if (favorited) {
      return favorited;
    }
    favorited = {};
    var list = cfg().favoritedVariantIds || [];
    for (var i = 0; i < list.length; i++) {
      favorited[String(list[i])] = true;
    }
    return favorited;
  }

  function paintButton(btn) {
    var id = String(btn.getAttribute('data-variant-id') || '');
    var on = !!favoritedSet()[id];
    var strings = cfg().strings || {};
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? strings.remove : strings.add;
    if (label) {
      btn.setAttribute('aria-label', label);
    }
  }

  function paintAll() {
    document.querySelectorAll('[data-wishlist-button]').forEach(paintButton);
  }

  function showFeedback(btn, message, isError) {
    var wrap = btn.closest('.ganymede-wishlist');
    if (!wrap) {
      return;
    }
    var el = wrap.querySelector('[data-wishlist-feedback]');
    if (!el) {
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('ganymede-wishlist__feedback--error', !!isError);
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      el.hidden = true;
    }, 8000);
  }

  async function onWishlistClick(ev) {
    var btn = ev.target.closest && ev.target.closest('[data-wishlist-button]');
    if (!btn) {
      return;
    }
    ev.preventDefault();

    var c = cfg();
    var strings = c.strings || {};

    if (!c.apiUrl) {
      return;
    }
    if (!c.customerLoggedIn) {
      window.alert(strings.loginRequired || 'Login required');
      return;
    }

    var handle = (btn.getAttribute('data-product-handle') || '').trim();
    var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    if (!handle || variantId <= 0) {
      window.alert(strings.badRequest || 'Invalid product');
      return;
    }

    if (btn.disabled) {
      return;
    }
    btn.disabled = true;

    /* すでにお気に入りなら解除。マイコレクションの削除ボタンと同じ
       action: 'favorite_remove' を同じエンドポイントに投げる。 */
    var isRemove = !!favoritedSet()[String(variantId)];
    var url = resolveProxyUrl(c.apiUrl);
    var reqBody = isRemove
      ? { action: 'favorite_remove', variant_id: variantId }
      : {
          action: 'favorite_add',
          product_handle: handle,
          variant_id: variantId,
          device: detectDevice(),
        };
    try {
      var res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(reqBody),
      });
      var text = await res.text();
      var data = parseResponseJson(text);

      if (window.GanymedeDebug && window.GanymedeDebug.logApi) {
        window.GanymedeDebug.logApi(reqBody.action, url, res, reqBody, text, data);
      }

      if (data.profile_incomplete) {
        window.location.href = c.mypageUrl || '/pages/mycollection';
        return;
      }

      if (!res.ok || data.__parseError || !data.ok) {
        throw new Error(data.error || data.__parseError || 'HTTP ' + res.status);
      }

      if (isRemove) {
        delete favoritedSet()[String(variantId)];
      } else {
        favoritedSet()[String(variantId)] = true;
      }
      paintButton(btn);
      showFeedback(btn, (isRemove ? strings.removed : strings.added) || 'Saved', false);
    } catch (err) {
      var base = isRemove ? strings.removeError || strings.error : strings.error;
      showFeedback(btn, (base || 'Error') + ': ' + err.message, true);
    } finally {
      btn.disabled = false;
    }
  }

  document.addEventListener('click', onWishlistClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (variant && variant.id) {
        syncVariantId(variant.id);
      }
    });
  }

  document.addEventListener('change', function (ev) {
    var input = ev.target;
    if (input && input.classList && input.classList.contains('product-variant-id')) {
      syncVariantId(input.value);
    }
  });
})();
